import React, { useEffect, useState } from "react";
import Brands from '../../components/brands/Brands';
import UpcomingEvents, { IUpcomingEvents } from '../../components/upcomingEvents/UpcomingEvents';
import MainCarousel from '../../components/mainCarousel/MainCarousel';
import Offers from '../../components/offers/Offers';
import styles from "./HomePage.module.css";
import { get } from '../../utilities/apiClient'
import ProductCategory from "../../components/productCategory/ProductCategory";
import WelcomeJKOA from "../../components/welcomeJKOA/WelcomeJKOA";
import { Col, Row } from "react-bootstrap";
import AwardsRecognition from "../../components/awardsRecognition/AwardsRecognition";
import BestSeller from "../../components/bestSellerModule/BestSellerModule";
import MetaComponent from "../../components/metaComponent/MetaComponent";
import { Helmet } from "react-helmet";

function HomePage() {
    const [carousel, setCarousel] = useState([]);
    const [brandList, setBrandList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [offerList, setOfferList] = useState([]);
    const [eventList, setEventList] = useState([]);
    const [bestSellerList, setBestSellerList] = useState([]);
    const [awardsList, setAwardsList] = useState([]);

    // meta Data
    // const [metaTitle, setMetaTitle] = useState<string>();
    const [title, settitle] = useState("")
    const [meta_Keywords, set_metaKeywords] = useState("")
    const [meta_Description, set_metaDescription] = useState("")
    const [metaKeywords, setMetaKeywords] = useState<string>();
    const [metaDescription, setMetaDescription] = useState<string>();

    useEffect(() => {
        getMainCarousel();
        settitle("John Keells Office Automation (Pvt) Ltd. ,  Sri Lanka | Conglomerates in Sri Lanka")
        set_metaKeywords("john keells, conglomerates Sri Lanka, retail, information technology, office automation, office automation products, photocopiers, mobiles, mobile phones, tablets, tabs,laptops, notebooks, multimedia projectors,projectors, tvs, business tvs,video walls, televisions, copiers, printers, duplicators, digital duplicators, multifunction printers, pos machines, point of sales solutions, receipt printers, barcode scanners, cash drawers,smart boards, white boards, interactive whiteboards, mobile accessories, speakers, earbuds, earphones, video walls, photocopier rental system, pnpl, toshiba ink, toshiba consumables, riso ink and masters, riso consumables, hp ink, hp consumables, asus, toshiba, samsung, riso fec, bixolon, zebex, hp, tacteasy, sinoview, viewsonic, hypergear, dynabook, branded products, print now pay later, best sellers, best selling mobiles, best selling laptops, best selling products, about john keells office automation,vacacies, john keells office automation vacancies, careers, jkoa, jkoa vacancies, special offers, online shopping, discounts, online, delivery, jkh, john keells, jkoa brands, john keells brands, jkoa awards, john keells awards, awards, jkoa best selling items, best price, best brands in sri lanka, office automation products in sri lanka, information technology in sri lanka, technology, jkoa news, john keells news, card offers, warranty, retail company, Toshiba after sales service, Samsung offers, printing solutions, Samsung Showroom, Toshiba Showroom, JKOA Showroom, Office equipment")
        set_metaDescription("John Keells Office Automation (Pvt) Ltd (JKOA) is a subsidiary within the retail sector of John Keells Holdings PLC, one of the most respected conglomerates in Sri Lanka. JKOA is the leader in office automation solutions, comprising a product portfolio of world-renowned brands.")
    }, [])


    function getMainCarousel() {
        get("WebModule/GetHomePage", {}, false)
            .then(res => {
                var response: any = res;
                if (response.data.statusCode === 200) {
                    setCarousel(response.data.result.banners);
                    setBrandList(response.data.result.brands);
                    setCategoryList(response.data.result.departments);
                    setOfferList(response.data.result.promotionHeaders);
                    setEventList(response.data.result.events);
                    setBestSellerList(response.data.result.bestSeller);
                    setAwardsList(response.data.result.awards);
                    
                    let metaKeyWord = "";
                    metaKeyWord = setMeta(response.data.result.promotionMetaData, 2);
                    if(metaKeyWord == "") metaKeyWord = setMeta(response.data.result.brandMetaData, 2);
                    else metaKeyWord  = metaKeyWord + ',' + setMeta(response.data.result.brandMetaData, 2);
                    setMetaKeywords(metaKeyWord)

                    let metaDescription = "";
                    metaDescription = setMeta(response.data.result.promotionMetaData, 3);
                    if(metaDescription == "") metaDescription = setMeta(response.data.result.brandMetaData, 3);
                    else metaDescription = metaDescription + ',' + setMeta(response.data.result.brandMetaData, 3);
                    setMetaDescription(metaDescription);
                    // setMetaDescription(setMeta(response.data.result.promotionMetaData, 3) + ',' + setMeta(response.data.result.brandMetaData, 3));                   
                }
                else {
                    console.log(response.data.errorList)
                }
            });
    }
    const img = "https://s3-us-west-2.amazonaws.com/s.cdpn.io/39255/face.png";

    function setMeta(data: any, id: number) {
        var result = data.filter((a: any) => a.metaTypeId == id);
        if (result[0].metaContent != null) {
            return result[0].metaContent;
        }
        else {
            return null;
        }
    }

    return (
        <React.Fragment>
            {metaDescription || metaKeywords ?
                <MetaComponent metaDescription={meta_Description + "," + metaDescription} 
                metaKeywords={meta_Keywords + "," + metaKeywords} metaTitle={title} />
                : 
                <MetaComponent metaDescription={meta_Description} 
                metaKeywords={meta_Keywords} metaTitle={title} />
            }

            {carousel.length > 0 ?
                <MainCarousel mainCarousel={carousel} />
                : null
            }

            <div className={`container ${styles.container}`}>
                <Row>
                    <Col lg="6" md="12" xs="12">
                        <Row>
                            <WelcomeJKOA />
                        </Row>
                    </Col>
                    <Col lg="6" md="12" xs="12">
                        {eventList.length >= 2 ?
                            <UpcomingEvents events={eventList} />
                            : null
                        }
                    </Col>
                </Row>

                {offerList.length > 2 ?
                    <Offers offers={offerList} />
                    : null
                }
                {categoryList.length > 0 ?
                    <ProductCategory productCategory={categoryList} />
                    : null
                }
                {
                    bestSellerList.length > 0 ?
                        <BestSeller productCard={bestSellerList} />
                        : null
                }
                {brandList.length > 0 ?
                    <Brands
                        brands={brandList}
                        subHeading={null}
                        mainHeading="Our Brands"
                        content="As the leading provider of technology driven office automation solutions, we bring you world renowned brands that you can trust, supported by the highest standards of service in the industry."
                        showButton={true}
                    />
                    : null
                }

                {awardsList.length > 0 ?
                    <AwardsRecognition awardCard={awardsList}/>
                    : null
                }
                
            </div>

        </React.Fragment>
    )
}

export default HomePage;